/** Set to false to disable image expansion, true to enable it */
export const TEMPORARILY_DISABLE_IMAGE_EXPANSION = true;

export const CARD_MAX_HEIGHT_PX = 480;
